import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AddPromptPayload, ChangePromptStatusPayload, DeletePromptPayload, PromptsState } from "./types";

export const initialState: PromptsState = {
  loading: false,
  loadError: null,
  items: null,
};

const promptsSlice = createSlice({
  name: "prompts",
  initialState,
  reducers: {
    fetchPrompts: (state) => {
      state.loading = true;
      state.loadError = null;
    },
    fetchPromptsSuccess: (state, action) => {
      state.loading = false;
      state.loadError = null;
      state.items = action.payload;
    },
    fetchPromptsFailure: (state, action: PayloadAction<string | undefined>) => {
      state.loading = false;
      state.loadError = action.payload ?? null;
    },

    addPromptSuccess: (state) => {
      state.loading = false;
    },
    addPromptFailure: (state) => {
      state.loading = false;
    },

    deletePrompt: (state, action: PayloadAction<DeletePromptPayload>) => {
      if (state.items) {
        state.items = state.items.filter((prompt) => prompt.id !== action.payload.id);
      }
    },
    deletePromptSuccess: (state) => {
      state.loading = false;
    },
    deletePromptFailure: (state) => {
      state.loading = false;
    },

    changePromptStatusSuccess: (state) => {
      state.loading = false;
    },
    changePromptStatusFailure: (state) => {
      state.loading = false;
    },
  },
});



export const addPrompt = createAction<AddPromptPayload>('prompts/addPrompt');
export const changePromptStatus = createAction<ChangePromptStatusPayload>('prompts/changePromptStatus');


export const {
  fetchPrompts,
  fetchPromptsSuccess,
  fetchPromptsFailure,
  deletePrompt,
  addPromptSuccess,
  addPromptFailure,
  changePromptStatusSuccess,
  changePromptStatusFailure,
  deletePromptSuccess,
  deletePromptFailure,
} = promptsSlice.actions;

export default promptsSlice.reducer;